// Rothko Colour Palettes adapted from https://github.com/mmerrittsmithc/rothko
const rothko_palettes = [
  // {
  //   idx: 1,
  //   title: "Magenta, Black, Green on Orange",
  //   clrs: ["#3D341C", "#D46438", "#6B8D4A", "#A65530", "#FDF5AB"],
  //   num_clrs: 5,
  // },
  {
    idx: 2,
    title: "Untitled 1949",
    clrs: ["#414030", "#9EA683", "#EAB23B", "#F3C855", "#DABF7B", "#F0D69A"],
    num_clrs: 6,
  },
  {
    idx: 3,
    title: "Number 5",
    clrs: ["#DD2B18", "#F86602", "#FBA901", "#F9C007"],
    num_clrs: 4,
  },
  {
    idx: 4,
    title: "Violet, Black, Orange, Yellow on White and Red",
    clrs: [
      "#B41840",
      "#C44045",
      "#F0C73C",
      "#F7E4D7",
      "#F1DBC7",
      "#DFC36D",
      "#DC9F4A",
      "#E79914",
      "#E48504",
      "#372412",
    ],
    num_clrs: 10,
  },
  // {
  //   idx: 5,
  //   title: "Violet, Black, Orange, Yellow on White and Red2",
  //   clrs: ["#B41840", "#F0C73C", "#F1DBC7", "#E48504", "#372412"],
  //   num_clrs: 5,
  // },
  {
    idx: 6,
    title: "White Center",
    clrs: ["#E27B98", "#E79C33", "#F3EBD3", "#D57254", "#8B624B"],
    num_clrs: 5,
  },
  // {
  //   idx: 7,
  //   title: "Blue, Green, and Brown",
  //   clrs: ["#231526", "#2A1D26", "#262F5B", "#3C529D", "#5B73C9", "#738BE0"],
  //   num_clrs: 6,
  // },
  // {
  //   idx: 8,
  //   title: "Purple, White, and Red",
  //   clrs: ["#6F5256", "#917264", "#9B907B", "#9A9994", "#878987"],
  //   num_clrs: 5,
  // },
  // {
  //   idx: 9,
  //   title: "Number 10",
  //   clrs: ["#4E5F71", "#7A9482", "#9EC0A7", "#C2C27F", "#C9A203", "#BE810D"],
  //   num_clrs: 6,
  // },
  // {
  //   idx: 10,
  //   title: "Rust and Blue",
  //   clrs: ["#342445", "#3855AE", "#3C5BBD"],
  //   num_clrs: 3,
  // },
  // {
  //   idx: 11,
  //   title: "Untitled 1953",
  //   clrs: ["#2D313B", "#AD6068", "#CC5177", "#D15C8D"],
  //   num_clrs: 4,
  // },
  // {
  //   idx: 12,
  //   title: "Ochre and Red on Red",
  //   clrs: ["#D2901D", "#B56C18", "#D15818", "#E43824"],
  //   num_clrs: 4,
  // },
  // {
  //   idx: 13,
  //   title: "Red, Black, White on Yellow",
  //   clrs: ["#342B25", "#EE5633", "#CF9A59", "#D2CFCE"],
  //   num_clrs: 4,
  // },
  // {
  //   idx: 14,
  //   title: "Green and Tangerine on Red",
  //   clrs: ["#E74607", "#383A39", "#C49261", "#CE6636"],
  //   num_clrs: 4,
  // },
  // {
  //   idx: 15,
  //   title: "Light Red Over Black",
  //   clrs: ["#FB3D1E", "#56372D", "#A4422C", "#CF3C23"],
  //   num_clrs: 4,
  // },
  {
    idx: 16,
    title: "Light Cloud, Dark Cloud",
    clrs: ["#FAEEEA", "#F4E4DD", "#CE917B", "#C55E48", "#B53832", "#872828"],
    num_clrs: 6,
  },
  // {
  //   idx: 17,
  //   title: "Number 14",
  //   clrs: ["#F96311", "#CE3803", "#A33003", "#201128", "#000000"],
  //   num_clrs: 5,
  // },
  // {
  //   idx: 18,
  //   title: "Orange, Red, Yellow",
  //   clrs: ["#E7602E", "#D55D2D", "#A84838", "#842B2A"],
  //   num_clrs: 4,
  // },
  {
    idx: 19,
    title: "Number 16",
    clrs: ["#12153D", "#1039A2", "#6B84C4", "#F7F3E8", "#E48107", "#D77508"],
    num_clrs: 6,
  },
  // {
  //   idx: 20,
  //   title: "Blue and Grey",
  //   clrs: ["#313B48", "#8D8B88", "#9B9692"],
  //   num_clrs: 3,
  // },
  {
    idx: 21,
    title: "Untitled 1969",
    clrs: ["#000000", "#3C3029", "#8D847D", "#D8CEC8", "#E7DDD5"],
    num_clrs: 5,
  },
];
export { rothko_palettes };
